<template>
  <b-card no-body>
    <b-table
      :items="items"
      :fields="fields"
      responsive
    >
      <template #cell(folio)="data">
        <div class="text-primary font-weight-bolder quote-folio-cell">
          <span>#{{ data.value }}</span>
          <small
            v-if="showNickname(data.item)"
            class="quote-nickname d-block mt-25"
          >
            {{ data.item.nickname }}
          </small>
        </div>
      </template>
      <template #cell(address)="data">
        <span class="font-weight-bolder">{{ data.item.address.formatted_address }}</span>
      </template>
      <template #cell(published_at)="data">
        <span>{{ data.value | date }}</span>
      </template>
      <template #cell(actions)>
        <div>
          <b-button
            class="mr-1"
            size="sm"
            variant="link"
          >
            <feather-icon
              size="18"
              icon="MoreVerticalIcon"
            />
          </b-button>
        </div>
      </template>
    </b-table>
  </b-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  components: {},

  props: {
    items: {
      type: Array,
      default() {
        return []
      },
    },
  },

  data() {
    return {
      fields: [
        {
          key: 'folio',
          label: 'Folio',
        },
        {
          key: 'address',
          label: this.$t('address'),
        },
        {
          key: 'published_at',
          label: this.$t('publishedDate'),
        },
      ],
    }
  },

  computed: {
    ...mapGetters('auth', ['currentUser']),
  },

  methods: {
    ...mapMutations('suppliers', {
      selectProvider: 'SET_SELECTED_SUPPLIER',
    }),
    ...mapMutations('branches', {
      selectBranch: 'SET_SELECTED_BRANCH',
    }),
    showNickname(item) {
      return ['admin', 'customer'].includes(this.currentUser?.role_name) && item.nickname
    },
  },
}
</script>

<style lang="scss" scoped>
.quote-folio-cell {
  line-height: 1.1;
}

.quote-nickname {
  color: #6c757d;
  font-weight: 600;
}
</style>
